const KEY = "aurelia-mail-compose-recovery";
const MAX_AGE_MS = 7 * 24 * 60 * 60 * 1000;

export type ComposeRecovery = {
  to: string;
  cc: string;
  subject: string;
  bodyHtml: string;
  savedAt: number;
};

function looksEmpty(html: string): boolean {
  return html
    .replace(/<br\s*\/?>/gi, " ")
    .replace(/<[^>]+>/g, " ")
    .replace(/&nbsp;/g, " ")
    .trim() === "";
}

/** Copie locale pendant la frappe. Ne part pas sur IMAP (ça bloquerait la boîte). */
export function writeComposeRecovery(draft: {
  to: string;
  cc: string;
  subject: string;
  bodyHtml: string;
}): void {
  try {
    if (!draft.to.trim() && !draft.cc.trim() && !draft.subject.trim() && looksEmpty(draft.bodyHtml)) {
      localStorage.removeItem(KEY);
      return;
    }
    const payload: ComposeRecovery = { ...draft, savedAt: Date.now() };
    localStorage.setItem(KEY, JSON.stringify(payload));
  } catch {
    /* quota / navigation privée */
  }
}

export function readComposeRecovery(): ComposeRecovery | null {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return null;
    const data = JSON.parse(raw) as ComposeRecovery;
    if (!data || typeof data.savedAt !== "number" || Date.now() - data.savedAt > MAX_AGE_MS) {
      localStorage.removeItem(KEY);
      return null;
    }
    if (!data.to.trim() && !data.cc.trim() && !data.subject.trim() && looksEmpty(data.bodyHtml || "")) {
      localStorage.removeItem(KEY);
      return null;
    }
    return data;
  } catch {
    return null;
  }
}

export function clearComposeRecovery(): void {
  try {
    localStorage.removeItem(KEY);
  } catch {
    /* ignore */
  }
}
